"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavPills = void 0;
var React = require("react");
var react_1 = require("react");
var generic_1 = require("../generic");
function getInitialPill(nav_id, default_pill) {
    var pill_id = parseInt(localStorage.getItem(nav_id));
    return pill_id ? pill_id : default_pill;
}
function useNavPills(nav_id, pills) {
    var _a = __read((0, react_1.useState)(getInitialPill(nav_id, pills.length > 0 ? pills[0].id : undefined)), 2), active_pill = _a[0], setActivePill = _a[1];
    function setActivePillId(pill_id) {
        localStorage.setItem(nav_id, pill_id.toString());
        setActivePill(pill_id);
    }
    var NavPills = function (_a) {
        var row_class = _a.row_class, a_class = _a.a_class;
        return (React.createElement("div", { className: row_class || "row" }, pills.map(function (pill) { return (React.createElement("div", { key: pill.id, className: a_class +
                (active_pill && active_pill == pill.id
                    ? " active"
                    : ""), onClick: function () { return setActivePillId(pill.id); } },
            React.createElement("a", null,
                pill.icon && React.createElement(generic_1.Icon, { name: pill.icon, size: "1x" }),
                " ",
                pill.text))); })));
    };
    return [active_pill, NavPills];
}
exports.useNavPills = useNavPills;
